var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-4"},[_c('ProjectUpsertComponent',{attrs:{"project":_vm.project},on:{"save":_vm.onSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }